import React from 'react';

const WEEKDAY_FULL = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];

// Weekday of an ISO date without going through UTC parsing.
const weekdayName = (iso) => {
    const [y, m, d] = iso.split('-').map(Number);
    return WEEKDAY_FULL[new Date(y, m - 1, d).getDay()];
};

export default function SuccessPage({ booking, service, onReset }) {
    // WEEKLY: the user books a weekday, not a calendar date — show the weekday.
    const when = booking?.date
        ? (service?.service_type === 'WEEKLY' ? weekdayName(booking.date) : booking.date)
        : null;

    return (
        <div className="success-page">
            <div className="success-icon">✓</div>
            <h2>Запись создана!</h2>
            <p>
                Вы успешно записались на <strong>{service?.name}</strong>
                {booking?.club_name && <> в клуб <strong>{booking.club_name}</strong></>}
                {when && (
                    <>
                        <br />
                        {when}{booking?.time ? ` в ${booking.time}` : ''}
                    </>
                )}
            </p>
            <button className="btn btn-primary" onClick={onReset}>
                Новая запись
            </button>
        </div>
    );
}
